import { Drawer as NovaBaseDrawer } from '@fme-nova/components'
import { Collapse as MuiCollapse, CollapseProps, Drawer, DrawerProps } from '@mui/material'

import { styled } from '../../theme'
import { createComponentWrapperWithRef, Z_INDEX } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

export const MuiDrawer: MsdkStyledComponent<DrawerProps> = styled(Drawer)`
  z-index: ${Z_INDEX.under_everything};
  & .MuiDrawer-paper {
    background-color: ${COLORS.components.navigation.main};
    border-radius: var(--none, 0);
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.2);
    color: ${COLORS.white.main};
  }
`

const NovaDrawer: MsdkStyledComponent<DrawerProps> = styled(NovaBaseDrawer)`
  z-index: ${Z_INDEX.under_everything};
  > .MuiPaper-root {
    border-radius: 0;
  }
`

export const Collapsible = createComponentWrapperWithRef<DrawerProps>(
  {
    mui: MuiDrawer,
    nova: NovaDrawer,
  },
  'Collapsible',
)

export const Collapse: MsdkStyledComponent<CollapseProps> = styled(MuiCollapse)``
